import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_authed/admin/venues")({
  component: VenuesPlaceholder,
})

function VenuesPlaceholder() {
  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight">Venues</h1>
      <p className="mt-2 text-sm text-[color:var(--muted-foreground)]">
        Phase 0 placeholder. Venue CRUD lands in Phase 2.
      </p>
    </div>
  )
}
